// Generated by CoffeeScript 2.7.0
var RedPacketQuotasTable;

import DataTableMixin from 'trunks/vue/admin/compositions/datable_table/mixin.js';

import ShowRedPacketQuotasModal from 'trunks/vue/admin/components/settings/settings_red_packet_quotas/show_red_packet_quotas_modal.js';

import EditRedPacketQuotasModal from 'trunks/vue/admin/components/settings/settings_red_packet_quotas/edit_red_packet_quotas_modal.js';

export default RedPacketQuotasTable = Vue.extend({
  mixins: [DataTableMixin],
  props: {
    resourceUrl: {
      type: String,
      required: true
    },
    speacialFields: {
      type: Array
    }
  },
  data: function() {
    return {
      headers: []
    };
  },
  template: `<div class="datable-table-wrapper">
  <v-table :headers="filterFields"
           :rows="recordRows"
           :selectable="false"
           :enableOperation="true"
           @rowClicked='rowClickedFunc'
           ref='bodyTable'>
    <template slot='header' slot-scope='{ header }'>
      <header-cell :field='header'
                   :enableColumnFilter='false' />
    </template>
    <template slot='body' slot-scope='{ cell }'>
      <field-cell :field='cell.field'
                  :entries='cell.entries'></field-cell>
    </template>
    <template slot='operation-cell' slot-scope='{ row }' v-if='row.id'>
      <button class="text-btn" @click="openDetailModal(row)">详情</button>
      <button class="text-btn ml-3" @click="openEditModal(row)">编辑</button>
    </template>
  </v-table>
  <paginator :resourceUrl='resourceUrl'
             :beforeRequestFunc='beforeRecordsRequestFunc'
             :afterRequestFunc='afterRecordsRequestFunc'
             @dataReceived='updateRecords'
             ref='paginator' />
</div>`,
  methods: {
    rowClickedFunc: function(event, row, child) {
      if (!row.id) {
        return;
      }
      return this.$refs.bodyTable.focusOnRow(row);
    },
    openDetailModal: function(row) {
      this.$refs.bodyTable.focusOnRow(row);
      return new ShowRedPacketQuotasModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('show-red-packet-quotas-modal-container'),
        propsData: {
          initialRedPacketQuotas: row.record
        }
      });
    },
    openEditModal: function(row) {
      this.$refs.bodyTable.focusOnRow(row);
      return new EditRedPacketQuotasModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('edit-red-packet-quotas-modal-container'),
        propsData: {
          initialRedPacketQuotas: row.record,
          callback: () => {
            return this.refreshData();
          }
        }
      });
    },
    _addSpecialFields: function(receivier, hidden_ids) {
      var speacialFields;
      speacialFields = this.speacialFields;
      _.each(speacialFields, function(field) {
        return receivier.push(field);
      });
      return receivier;
    },
    _formatRecords: function(records) {
      return records;
    },
    __parseSpecialCells: function(field, record, grouped_entries, rowspan, receivier) {
      if (!record.id) {
        return;
      }
      switch (field.id) {
        case -1:
          return receivier.entries = [
            {
              field_id: -1,
              value: record.user
            }
          ];
        case -2:
          return receivier.entries = [
            {
              field_id: -2,
              value: record.user.identifier
            }
          ];
        case -3:
          return receivier.entries = [
            {
              field_id: -3,
              value: record.user.phone
            }
          ];
        case -4:
          return receivier.entries = [
            {
              field_id: -4,
              value: `${record.total_amount}/${record.total_amount}`
            }
          ];
        default:
          return this.__parseNormalCells(field, record, grouped_entries, rowspan, receivier);
      }
    }
  }
});
